import { apiGet, apiGetList } from "services/api";

/**
 * Общие запросы справочных данных.
 * База большая (до 500к записей) — всегда передаём пагинацию,
 * где список нужен целиком, грузим постранично большими страницами.
 */

const FULL_PAGE_SIZE = 1000;

/** Загрузить все страницы списка (для справочников: склады, прайсы, ед.изм.) */
export async function fetchAllPages(url, params = {}, pageSize = FULL_PAGE_SIZE) {
  const all = [];
  let page = 1;

  for (;;) {
    const { items, meta } = await apiGetList(url, { ...params, page, pageSize });
    all.push(...items);

    const totalPages = meta?.totalPages ?? 1;
    if (!items.length || page >= totalPages) break;
    page += 1;
  }

  return all;
}

export const getStores = (params) =>
  apiGetList("stores", { page: 1, pageSize: 500, ...params });

export const getPriceLists = () =>
  apiGetList("stores/pricelists", { page: 1, pageSize: 500 });

export const getArticles = (params) =>
  apiGetList("article", { page: 1, pageSize: 500, ...params });

export const getMeasureUnits = () =>
  apiGetList("documents/measureunits", { page: 1, pageSize: 500 });

export const getEmployeesGroups = () =>
  apiGetList("users/get-groups", { page: 1, pageSize: 500 });

export const getOperationTypes = () =>
  apiGetList("documents/operation-types", { page: 1, pageSize: 100 });

export const getSettings = () => apiGet("settings");
